import { ConnectButton } from '@rainbow-me/rainbowkit'

const btnBase: React.CSSProperties = {
	fontFamily: 'Inter, sans-serif',
	letterSpacing: 'normal',
	background: '#000',
	color: '#fff',
	borderRadius: '12px',
	padding: '8px 16px',
	border: 'none',
	cursor: 'pointer',
	fontSize: '14px',
	lineHeight: '20px',
}

const wrongNetworkBtn: React.CSSProperties = {
	...btnBase,
	background: 'var(--failed, #ff494a)',
	boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
}

const chainBtn: React.CSSProperties = {
	...btnBase,
	background: 'transparent',
	color: 'inherit',
	display: 'flex',
	alignItems: 'center',
	boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
	cursor: 'default',
}

const accountBtn: React.CSSProperties = {
	...btnBase,
	boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
}

export const ConnectWalletBtn = () => {
	return (
		<ConnectButton.Custom>
			{({
				account,
				chain,
				openAccountModal,
				openChainModal,
				openConnectModal,
				mounted,
			}) => {
				const ready = mounted
				const connected = ready && account && chain

				return (
					<div
						{...(!ready && {
							'aria-hidden': true,
							style: {
								opacity: 0,
								pointerEvents: 'none' as const,
								userSelect: 'none' as const,
							},
						})}
					>
						{(() => {
							if (!connected) {
								return (
									<button
										onClick={openConnectModal}
										type="button"
										style={btnBase}
									>
										Connect wallet
									</button>
								)
							}

							if (chain.unsupported) {
								return (
									<button
										onClick={openChainModal}
										type="button"
										style={wrongNetworkBtn}
									>
										Wrong network
									</button>
								)
							}

							return (
								<div style={{ display: 'flex', gap: '16px' }}>
									<button
										disabled
										type="button"
										style={chainBtn}
									>
										{chain.hasIcon && (
											<div
												style={{
													background:
														chain.iconBackground,
													borderRadius: '50%',
													overflow: 'hidden',
													marginRight: '8px',
													width: '20px',
													height: '20px',
												}}
											>
												{chain.iconUrl && (
													<img
														alt={
															chain.name ??
															'Chain icon'
														}
														src={chain.iconUrl}
														style={{
															width: '20px',
															height: '20px',
														}}
													/>
												)}
											</div>
										)}
										{chain.name}
									</button>

									<button
										onClick={openAccountModal}
										type="button"
										style={accountBtn}
									>
										{account.displayName}
									</button>
								</div>
							)
						})()}
					</div>
				)
			}}
		</ConnectButton.Custom>
	)
}
